import getApi from '../../api'
import { SurveyDuplicationPayload } from '../../model/Survey'

export const duplicateSurveyToAnotherUser = (surveyDuplication: SurveyDuplicationPayload) =>
  getApi().post<void>(`admin/surveys/clone`, surveyDuplication)
